/* Carrusel de fotos de la tarjeta de producto (portada).
   - Avanza solo cada 5 s, en bucle.
   - Se pausa al pasar el raton y cuando la tarjeta no esta en pantalla.
   - Respeta a quien pide menos movimiento. */
(function () {
  var INTERVALO = 2000;
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function puntos(track) {
    return track.parentElement.querySelectorAll('.mm-card-dots__dot');
  }

  function marcar(track) {
    var i = Math.round(track.scrollLeft / track.clientWidth);
    var ds = puntos(track);
    for (var d = 0; d < ds.length; d++) {
      ds[d].classList.toggle('is-active', d === i);
    }
  }

  // Animacion propia: no dependemos de scroll-behavior, que no todos los
  // navegadores aplican al asignar scrollLeft.
  function irA(track, i) {
    var destino = track.clientWidth * i;
    if (quieto) { track.scrollLeft = destino; return; }
    var origen = track.scrollLeft;
    var t0 = null;
    var DUR = 420;
    function paso(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / DUR, 1);
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2; // easeInOutQuad
      track.scrollLeft = origen + (destino - origen) * e;
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  // Clic en un puntito
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.mm-card-dots__dot');
    if (!dot) return;
    e.preventDefault();
    var media = dot.closest('.mm-product-card__media');
    var track = media && media.querySelector('[data-card-slider]');
    if (!track) return;
    track.dataset.pausa = '1'; // si el visitante elige, dejamos de rotar
    irA(track, Number(dot.dataset.i));
  });

  // Punto activo segun la foto visible
  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (t.classList && t.classList.contains('mm-card-slider')) marcar(t);
    },
    true
  );

  function arrancar() {
    var tracks = document.querySelectorAll('[data-card-slider]');
    if (!tracks.length || quieto) return;

    tracks.forEach(function (track) {
      var media = track.closest('.mm-product-card__media');
      media.addEventListener('mouseenter', function () { track.dataset.hover = '1'; });
      media.addEventListener('mouseleave', function () { delete track.dataset.hover; });

      // Por defecto rota; el observador solo la pausa si sale de pantalla.
      track.dataset.visible = '1';
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entradas) {
          entradas.forEach(function (en) {
            if (en.isIntersecting) { track.dataset.visible = '1'; }
            else { delete track.dataset.visible; }
          });
        }, { threshold: 0.2 }).observe(track);
      }
    });

    setInterval(function () {
      tracks.forEach(function (track) {
        if (track.dataset.pausa || track.dataset.hover || !track.dataset.visible) return;
        var total = track.children.length;
        if (total < 2) return;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        irA(track, (i + 1) % total);
      });
    }, INTERVALO);
  }

  // El script puede cargarse despues de DOMContentLoaded: arrancamos igual.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
